export const IMAGE_SIZE = 400
